/**
 * RequesterCell — celula de exibicao do solicitante de um chamado.
 *
 * Spec: docs/CHAMADOS_VISIBILIDADE_SPEC.md §9.3.3
 *
 * - Avatar com iniciais (max 2 letras) + nome truncado em 140px.
 * - Sufixo " (voce)" quando isMe=true.
 * - Fallback "—" se name vazio/null.
 */
import { Group, Avatar, Text } from '@mantine/core'

export interface RequesterCellProps {
  name: string | null
  isMe?: boolean
}

function initials(name: string): string {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0])
    .join('')
    .toUpperCase()
}

export function RequesterCell({ name, isMe }: RequesterCellProps) {
  if (!name) {
    return (
      <Text size="sm" c="dimmed">
        —
      </Text>
    )
  }
  const display = isMe ? `${name} (voce)` : name
  return (
    <Group gap={6} wrap="nowrap">
      <Avatar size="sm" radius="xl" color="blue" aria-hidden="true">
        {initials(name)}
      </Avatar>
      <Text size="sm" truncate maw={140} title={display}>
        {display}
      </Text>
    </Group>
  )
}
